import { DiscountState } from "./Discount-State";

export default function discountReducer(state = DiscountState, action) {
  let { data } = JSON.parse(JSON.stringify(state));
  let { name, value } = action;

  switch (action.type) {
    case "TOGGLE-DISCOUNT-LIST-FILTER":
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      let toggle = true;
      if (toggle) {
        if (name === "limit") {
          data.params.page = 1;
        }
        data.params[name] = value;
      }
      return { ...state, data };

    case "TOGGLE-RESET-DISCOUNT":
      data.params.page = 1;
      data.params.q = "";
      data.payload.initialLoading = true;
      return { ...state, data };

    default:
      return state;
  }
}
